import cn from 'classnames';
import { PropsWithChildren, useState } from 'react';
import { InteractiveDiv } from '@Components/InteractiveEl';

interface ObservationCardProps extends PropsWithChildren {
  severity: string;
  title: string;
  note: string;
  more?: string;
}

/**
 * One severity-bordered, expandable finding (observation, gap, overlap, or
 * suggestion). Mirrors the reference tool's obsRow(): left border + severity
 * tag colored by class, note + italic "why this matters" on expand.
 */
export const ObservationCard = ({
  severity,
  title,
  note,
  more,
  children
}: ObservationCardProps) => {
  const [open, setOpen] = useState(false);
  const sev = severity.toLowerCase().startsWith('s') ? 'opportunity' : severity.toLowerCase();

  return (
    <div className={cn('digital-audit-obs', sev)}>
      <InteractiveDiv className='digital-audit-obs-head' onClick={() => setOpen(v => !v)}>
        <span className={cn('digital-audit-obs-sev', sev)}>{severity}</span>
        <span className='digital-audit-obs-title'>{title}</span>
        {children}
        <span className='digital-audit-obs-chev'>{open ? '−' : '+'}</span>
      </InteractiveDiv>
      {open && (
        <>
          <div className='digital-audit-obs-note'>{note}</div>
          {more && <div className='digital-audit-obs-more'>{more}</div>}
        </>
      )}
    </div>
  );
};
